import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { IconButton, Popover, Unstable_Grid2 as Grid } from '@mui/material';
import CircleIcon from '@mui/icons-material/Lens';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { GroupColorMap, UpdateGroupInput } from 'api';
import { useGroupData } from 'features/groups/hooks';

import { getGroupHexColor } from '../../helpers';
import theme from 'theme';

interface IProps {
  anchorEl: HTMLElement;
  onClose: () => void;
}

const ColorPicker: FC<IProps> = ({ anchorEl, onClose }) => {
  const { groupColors } = useGroupData();
  const { values, setFieldValue } = useFormikContext<UpdateGroupInput>();

  const hexColor = getGroupHexColor(groupColors, values.color);

  function handleColorChange(groupColor: GroupColorMap) {
    setFieldValue('color', groupColor.group_color);
    onClose();
  }

  function renderColor(groupColor: GroupColorMap) {
    const Icon = groupColor.hex === hexColor ? CheckCircleIcon : CircleIcon;

    return (
      <Grid key={groupColor.hex} xs={1} display="flex" justifyContent="center">
        <IconButton
          onClick={() => handleColorChange(groupColor)}
          size="large"
          sx={{ padding: 0, width: 30, height: 30 }}
        >
          <Icon sx={{ color: groupColor.hex }} fontSize="large" />
        </IconButton>
      </Grid>
    );
  }

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Grid
        container
        columns={4}
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{ maxWidth: 176, padding: theme.spacing(2) }}
      >
        {groupColors.map(renderColor)}
      </Grid>
    </Popover>
  );
};

export default ColorPicker;
